var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"campo",class:("col grid-12-s " + (_vm.f.tamanho == 'P' && 'g3') + " " + (_vm.f.tamanho == 'M' && 'g5') + " " + (_vm.f.tamanho == 'G' && 'g12'))},[_c('label',[_vm._v(_vm._s(_vm.f.rotulo))]),(!_vm.read)?[(_vm.f.tipo == 'texto')?_c('input',{attrs:{"placeholder":_vm.f.rotulo},domProps:{"value":_vm.v},on:{"change":function (ref){
	var value = ref.target.value;

	return _vm.up(value);
}}}):_vm._e(),(_vm.f.tipo == 'inteiro')?_c('input',{attrs:{"placeholder":_vm.f.rotulo,"type":"number"},domProps:{"value":_vm.v},on:{"change":function (ref){
	var value = ref.target.value;

	return _vm.up(value);
}}}):_vm._e(),(_vm.f.tipo == 'data')?_c('input',{attrs:{"type":"date","placeholder":_vm.f.rotulo},domProps:{"value":_vm.v},on:{"change":function (ref){
	var value = ref.target.value;

	return _vm.up(value);
}}}):_vm._e(),(_vm.f.tipo == 'hora')?_c('input',{attrs:{"placeholder":_vm.f.rotulo,"type":"time"},domProps:{"value":_vm.v},on:{"change":function (ref){
	var value = ref.target.value;

	return _vm.up(value);
}}}):_vm._e(),(_vm.f.tipo == 'real')?_c('Money',_vm._b({attrs:{"value":_vm.v,"placeholder":"0,00"},on:{"change":function (ref){
	var value = ref.target.value;

	return _vm.up(value);
}}},'Money',_vm.money,false)):_vm._e(),(_vm.f.tipo == 'lista')?_c('select',{attrs:{"selected":_vm.v},on:{"change":function (ref){
	var value = ref.target.value;

	return _vm.up(value);
}}},[_c('option',{domProps:{"value":null}},[_vm._v("Selecione")]),_vm._l((_vm.f.itens_lista),function(i){return _c('option',{domProps:{"value":i}},[_vm._v(_vm._s(i))])})],2):_vm._e()]:[_c('strong',[_vm._v(_vm._s(_vm.v))])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }